var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoin98(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40.7 40",
    style: {
      enableBackground: "new 0 0 40.7 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D9B432;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.3,0H7.4C3.3,0,0,3.3,0,7.3v25.4C0,36.7,3.3,40,7.4,40h25.9c4.1,0,7.4-3.3,7.4-7.3V7.3 C40.7,3.3,37.4,0,33.3,0L33.3,0z M27,10c3,0,5.5,2.4,5.5,5.4c0,0.9-0.2,1.8-0.6,2.6c-0.7-0.5-1.5-1-2.3-1.3c0.2-0.4,0.3-0.9,0.3-1.3 c0-1.5-1.3-2.8-2.8-2.8c-1.6,0-2.8,1.3-2.8,2.8c0,0.5,0.1,0.9,0.3,1.3c-0.8,0.3-1.6,0.7-2.3,1.3c-0.5-0.8-0.6-1.7-0.6-2.6 C21.6,12.4,24,10,27,10z M13.7,30c-3,0-5.5-2.4-5.5-5.4h2.6c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8h2.6C19.2,27.6,16.7,30,13.7,30 L13.7,30z M13.7,22.5c-3.5,0-6.3-2.8-6.3-6.2c0-3.4,2.8-6.3,6.3-6.3s6.4,2.8,6.4,6.3C20.1,19.7,17.2,22.5,13.7,22.5L13.7,22.5z  M27,30c-3.5,0-6.4-2.8-6.4-6.2c0-3.5,2.8-6.3,6.4-6.3c3.5,0,6.3,2.8,6.3,6.3C33.4,27.2,30.5,30,27,30L27,30z M30.8,23.7 c0,2.1-1.7,3.7-3.8,3.7s-3.8-1.7-3.8-3.7c0-2.1,1.7-3.7,3.8-3.7C29.1,20.1,30.8,21.7,30.8,23.7z M17.4,16.3c0,2.1-1.7,3.7-3.8,3.7 c-2.1,0-3.8-1.7-3.8-3.7c0-2.1,1.7-3.7,3.8-3.7C15.8,12.6,17.4,14.2,17.4,16.3L17.4,16.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin98);
export default __webpack_public_path__ + "static/media/coin98.d54315c69f0b4aa92134b839290983f5.svg";
export { ForwardRef as ReactComponent };